import { OrderStatus } from "@/enums";

export const orderStatuses = {
  [OrderStatus.UNKNOWN]: "Unknown",
  [OrderStatus.SAVED]: "Saved",
  [OrderStatus.PAID]: "Paid",
  [OrderStatus.CANCELLED]: "Cancelled",
};
